import React, { Component } from 'react'
import firebase from "./Firebase"
import Loader from 'react-loader';
import { connect } from 'react-redux';
import { LOGIN_APPROVED } from '../constants/actionTypes';

const mapStateToProps = state => {
    return {
        fbToken: state.common.fbToken
    }
};

const mapDispatchToProps = dispatch => ({
    onLoginApprove: (fbToken) => dispatch({ type: LOGIN_APPROVED, payload: fbToken }),
});

class SignIn extends Component {
    constructor(props) {
        super(props)

        this.state = {
            email: '',
            password: '',
            submitted: false,
            forgotPasswordClicked: false,
            showPasswordResetEmail: false,
            verificationEmailSent: false,
            showAlert: false,
            alertMessage: '',
            loadSpinner: false
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handlerPasswordResetSignInClick = () => {
        this.setState({ showPasswordResetEmail: false })
    }

    handleChange(e) {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    handleSubmit(e) {
        e.preventDefault();
        this.setState({ submitted: true });
        const { email, password } = this.state;
        if (email && password) {
            this.setState({ loadSpinner: true });
            firebase.auth().signInWithEmailAndPassword(email, password).then(user => {
                var currentUser = firebase.auth().currentUser;
                currentUser.getIdToken().then((data) => {
                    const fbToken = data;
                    this.props.onLoginApprove(fbToken);
                    const expirationDuration = 1000 * 60 * 60 * 12 * 2;// 24 hours
                    const currentTime = new Date().getTime();
                    const verificationEmailTimeStamp = localStorage.getItem("rfr_emvts")
                    if (!currentUser.emailVerified && (verificationEmailTimeStamp === null || (verificationEmailTimeStamp && (currentTime - verificationEmailTimeStamp) > expirationDuration))) {
                        currentUser.sendEmailVerification().then(() => {
                            localStorage.setItem("rfr_emvts", currentTime)
                            this.setState({ verificationEmailSent: true, loadSpinner: false });
                        });
                    } else {
                        this.props.history.push("/");
                        this.setState({ loadSpinner: false });
                    }
                });
            }).catch(error => {
                if (error.code === 'auth/wrong-password' || error.code === 'auth/user-not-found') {
                    this.setState({ alertMessage: 'Incorrect Email / Password.', loadSpinner: false, showAlert: true })
                } else {
                    this.setState({ alertMessage: error.message, loadSpinner: false, showAlert: true })
                }
            });
        }
    }

    forgotPasswordClickHandler = (event) => {
        this.setState({ forgotPasswordClicked: true });
        const { email } = this.state;
        if (email) {
            this.setState({ loadSpinner: true });
            firebase.auth().sendPasswordResetEmail(email).then(() => {
                this.setState({ loadSpinner: false, showPasswordResetEmail: true, showAlert: false, password: '' });
            }).catch(error => {
                if (error.code === 'auth/user-not-found') {
                    this.setState({ loadSpinner: false, alertMessage: 'Email not found, please register.', showAlert: true })
                } else {
                    this.setState({ loadSpinner: false, alertMessage: error.message, showAlert: true })
                }
            });
        }
    }

    render() {
        const { email, password, submitted, forgotPasswordClicked, showPasswordResetEmail, verificationEmailSent, showAlert, alertMessage, loadSpinner } = this.state;
        let component;

        if (showPasswordResetEmail) {
            component = (
                <div className="login-register-page container page">
                    <div className="row form-container">
                        <div className="col-lg-4 col-lg-offset-4 col-md-6 col-md-offset-6 col-sm-6 col-sm-offset-6 col-xs-8 form-center form-box">
                            <div className="form-group">
                                <h6>Password Reset</h6>
                                <p className="break-line">A link has been sent to <br /> <strong>{email}</strong><br />Please click the link to reset password.<br /><br />Press Sign in to go back on Sign-in page.</p>
                                <button autoFocus className="btn btn-primary btn-block" onClick={this.handlerPasswordResetSignInClick}>Sign in</button>
                            </div>
                        </div>
                    </div>
                </div>);
        }
        else if (verificationEmailSent) {
            component = (
                <div className="login-register-page container page">
                    <div className="row form-container">
                        <div className="col-lg-4 col-lg-offset-4 col-md-6 col-md-offset-6 col-sm-6 col-sm-offset-6 col-xs-8 form-center form-box">
                            <form name="form" className="mt-2" onSubmit={this.handleSubmit} >
                                <div className="form-group">
                                    <h6>Verification Email Sent</h6>
                                    <p className="break-line">A link has been sent to <strong>{email}</strong> for email verification. Please click the link in the email within 24 hrs to complete registration otherwise you will be asked to Sign-in again.<br /><br /> Press continue to view latest data.</p>
                                    <button className="btn btn-primary btn-block" onClick={() => { this.props.history.push("/"); }}>Continue</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>);
        }
        else {
            component = (
                <div className="login-register-page container page">
                    <div className="row form-container">
                        <div className="col-lg-4 col-lg-offset-4 col-md-6 col-md-offset-6 col-sm-6 col-sm-offset-6 col-xs-8 form-center form-box">
                            <div className={"alert alert-danger text-center" + (showAlert ? " show" : " hide")}>{alertMessage}</div>
                            <h5 className="text-center">Sign in</h5>
                            {/* <div className="form-box-licence">
                                <p className="p-zero-margin-bottom">As per the Bank of England licencing you need to Register / Sing-in to view the latest data, there is no cost involved, its simply in place to meet the BOE licencing requirement.</p>
                            </div> */}
                            <form name="form" className="mt-2" onSubmit={this.handleSubmit}>
                                <div className={'form-group' + ((submitted && !email) || (forgotPasswordClicked && !email) ? ' has-error' : '')}>
                                    <h6>Email</h6>
                                    <input type="email" className="form-control" name="email" value={email} onChange={this.handleChange} />
                                    {((submitted && !email) || (forgotPasswordClicked && !email)) &&
                                        <div className="help-block">Email is required</div>
                                    }
                                </div>
                                <div className={'form-group' + (submitted && !password ? ' has-error' : '')}>
                                    <h6>Password</h6>
                                    <input type="password" className="form-control" name="password" value={password} onChange={this.handleChange} />
                                    {submitted && !password && <div className="help-block">Password is required</div>}
                                </div>
                                <div className="form-group margin-top-minus-five-px">
                                    <a className="btn btn-link pull-right " onClick={this.forgotPasswordClickHandler}>Forgot?</a>
                                </div>
                                <div className="form-group text-xs-center">
                                    {loadSpinner && <Loader className="loader margin-left-fourty-px" color='#6f2c91' scale='0.48' loaded={false} />}
                                </div>
                                <div className="form-group">
                                    <button className="btn btn-primary btn-block" disabled={loadSpinner}>Sign in - Existing User</button>
                                </div>
                                <div className="form-group text-xs-center"><span>OR</span></div>
                            </form>
                            <div className="form-group">
                                <button className="btn btn-primary btn-block" disabled={loadSpinner} onClick={() => { this.props.history.push("/Register"); }}>Register - New User</button>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
        return component;
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SignIn);


// WEBPACK FOOTER //
// ./src/components/SignIn.js